













import { Component, Prop, Vue } from 'vue-property-decorator';
import { Common } from '@/core/Common';
import { FView } from '@/core/FView';
import { DataType } from '@/core/data/DataType';
import { EntranceVisitors } from '@/core/data/sets/computed/EntranceVisitors';
import { EnterExitDailyRecord } from '@/core/data/sets/EnterExitDailyRecord';

@Component ({
  components: {
      
  },
})
export default class extends Vue {
    @Prop() sourceDataSet!: EnterExitDailyRecord[];

    getDataSet() {
        return EntranceVisitors.getEntrancesVisitors(this.sourceDataSet);
    }
}
